<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.guestbookEdit") }}</h3>
            </div>
            <div class="card-body p-0">
                <div class="p-4">
                    <GuestbookForm :guestbook="guestbook" ref="guestbookForm" @submit="editGuestbook" />
                </div>
            </div>
        </div>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
        </div>
    </div>
</template>

<script>
    import GuestbookForm from '@/components/GuestbookForm.vue';
    import { formatForBackend } from '@/utils/date';

    export default {
        components: {
            GuestbookForm,
        },
        data() {
            return {
                guestbook: {}
            }
        },
        created() {
            this.getGuestbook();
        },
        methods: {
            getGuestbook() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/guestbooks/${this.$route.params.id}/edit`)
                .then(response => {
                    this.guestbook = response.data;
                })
                .catch(error => {
                    console.error("Error loading guestbook", error);
                });
            },
            submitForm() {
                if (this.$refs.guestbookForm?.submitForm) {
                    this.$refs.guestbookForm.submitForm();
                }
            },
            editGuestbook(data) {
                const formData = {
                    name: data.name,
                    company: data.company,
                    cardNumber: data.cardNumber,
                    cardType: data.cardType,
                    expectedFrom: formatForBackend(data.expectedFrom),
                    expectedTo: formatForBackend(data.expectedTo),
                    status: data.status,
                    isTrained: data.isTrained,
                }

                this.$store.getters.api.patch(`/${this.$route.params.slug}/guestbooks/${this.$route.params.id}/edit`, formData)
                .then(response => {
                    this.$router.replace({
                        name: "guestbookDetailView",
                        params: {
                            slug: this.$route.params.slug,
                            id: response.data.id,
                        }
                    });
                })
                .catch(error => {
                    console.error("Error editing vehicle entry", error);
                });
            },
        }
    }
</script>